// @mui
import { enUS, frFR, zhCN, viVN, arSD } from '@mui/material/locale';
// routes
import { PATH_DASHBOARD, PATH_LINGUIST } from './routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API_KEY || '';

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

// PORTALE MEDIATORI (AG Mediators / ci-ag-mediation-hub)
// ----------------------------------------------------------------------
// Decisione 14/09/2026 (report di follow-up, P0 #1): il mediatore vive in UN
// SOLO portale, e quel portale è AG Mediators — lì c'è già l'intero ciclo
// (proposta, accetta/rifiuta, dettagli, check-in/check-out, storico) e lì i
// mediatori hanno le credenziali (Supabase). Universe non è più una
// destinazione per loro: le rotte di mediazione lato vendor rimandano qui.
// Nessun default hard-coded: un dominio sbagliato manderebbe i mediatori su
// una pagina morta senza che nessuno se ne accorga. Se la variabile manca, la
// UI lo dice invece di offrire un link rotto.
export const MEDIATOR_PORTAL_URL = String(
  process.env.REACT_APP_MEDIATOR_PORTAL_URL || ''
)
  .trim()
  .replace(/\/+$/, '');

// Recapito operativo di chi gestisce gli incarichi di mediazione. Serve solo
// come via d'uscita quando l'indirizzo del portale non è noto: il report
// post-update (14/09/2026, P0 #1) segnala che dire al mediatore "contatta il
// project manager" senza dargli un recapito lo lascia esattamente dov'era.
export const MEDIATION_SUPPORT_EMAIL = String(
  process.env.REACT_APP_MEDIATION_SUPPORT_EMAIL ||
    'booking@congressiinternazionali.it'
).trim();

export const mediatorPortalAssignmentUrl = (allocationId) => {
  if (!MEDIATOR_PORTAL_URL) return '';
  return allocationId
    ? `${MEDIATOR_PORTAL_URL}/incarichi/${allocationId}`
    : `${MEDIATOR_PORTAL_URL}/incarichi`;
};

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.app; //
// ROOT PATH AFTER LOGIN SUCCESSFUL FOR LINGUISTS
export const PATH_AFTER_LOGIN_LINGUIST = PATH_LINGUIST.user.editProfile; // as '/dashboard/app'

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20
};

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'default',
  themeStretch: false,
  viewNavbar: true
};

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/assets/icons/flags/ic_flag_en.svg'
  },
  {
    label: 'Italian',
    value: 'it',
    systemValue: enUS,
    icon: '/assets/icons/flags/ic_flag_it.svg'
  }
  // {
  //   label: 'French',
  //   value: 'fr',
  //   systemValue: frFR,
  //   icon: '/assets/icons/flags/ic_flag_fr.svg',
  // },
  // {
  //   label: 'Vietnamese',
  //   value: 'vn',
  //   systemValue: viVN,
  //   icon: '/assets/icons/flags/ic_flag_vn.svg',
  // },
  // {
  //   label: 'Chinese',
  //   value: 'cn',
  //   systemValue: zhCN,
  //   icon: '/assets/icons/flags/ic_flag_cn.svg',
  // },
  // {
  //   label: 'Arabic (Sudan)',
  //   value: 'ar',
  //   systemValue: arSD,
  //   icon: '/assets/icons/flags/ic_flag_sa.svg',
  // },
];

export const defaultLang = allLangs[0]; // English
